import(/* webpackMode: "eager" */ "/app/main/app/[locale]/coding/list/block/page.tsx");
